/* eslint no-eval: 0 */
import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import {Formik, Form, FormikValues, FormikProps} from 'formik'
import BuilderForm, {ToArray, checkChildren} from './BuilderForm'
import {SubmitForm} from './SubmitForm'
import { useHistory } from "react-router-dom";
import * as Yup from 'yup'
import * as _ from 'lodash'
import {useIntl} from 'react-intl'

interface FormConfig {
    items: any
    user: number
    nid: string
    type: string
    destination: string
    form_name: string
    state_modal?: any
    success_message?: any
};

const FormStepHorizontal: React.FC<FormConfig> = (props) => {
    const stepperRef = useRef<HTMLDivElement | null>(null)
    const stepper = useRef<StepperComponent | null>(null)
    const [isSubmitButton, setSubmitButton] = useState(false)
    const [submitId, setSubmitId] = useState(false)
    const [errorMess, setErrorMess] = useState('')
    
    const form_name = props.form_name

    let schemaObject: any = {};
    var initValues : any = {};
    let history = useHistory();

    const intl = useIntl()

    const getValidationRule = (formField : any, form_name: any) => {
        let fieldValidationRule = '';
        fieldValidationRule = dataTypeValidation(formField.type, fieldValidationRule);
        fieldValidationRule = requiredValidation(formField.required, fieldValidationRule, formField.states_required, formField.states, formField.name, formField.states_force);
        return fieldValidationRule;
    };

    const dataTypeValidation = (fieldType : string, validationRule : any) => {
        let typeValidation = validationRule;
        switch(fieldType){
            case 'float':
                typeValidation = Yup.number().positive()
                break;
            case 'date':
                typeValidation = Yup.date().max(new Date());
                break;
            default:
                typeValidation = Yup.string();
        }
        return typeValidation;
    };

    const requiredValidation = (fieldRequired: boolean, validationRule: any, statesRequired: any, states: any, name: string, statesForce: any) => {
        let requireValidation = _.cloneDeep(validationRule);
        
        if(statesForce?.field_category.length > 0){
            return requireValidation.when(['field_category'], (category: string) => {
                if(statesForce.field_category.includes(parseInt(category))){
	             
                    window.FormSettings[props.form_name][name].required = true
					return requireValidation.required("Cannot be blank")
                }
                else{
                    if(statesRequired?.field_category.length > 0 && states?.field__article_classe?.length > 0) {
                        return requireValidation.when(['field_category', 'field__article_classe'], (category: string, classe: string) => {
                            let convert = classe == 'true' ? 1 : 0;
							
							var required = (statesRequired.field_category.includes(parseInt(category)) && states.field__article_classe.includes(convert))
							
                            window.FormSettings[props.form_name][name].required = required
                             
                            return required ? requireValidation.required("Cannot be blank") : requireValidation;
                        })
                    }
                }
            })
        }
        else if(statesRequired?.field_category.length > 0 && states?.field__article_classe?.length > 0) {
             return requireValidation.when(['field_category', 'field__article_classe'], (category: string, classe: string) => {
                 let convert = classe == 'true' ? 1 : 0;
                 
				 var required = (statesRequired.field_category.includes(parseInt(category)) && states.field__article_classe.includes(convert))
                 window.FormSettings[props.form_name][name].required = required

                 return required ? requireValidation.required("Cannot be blank") : requireValidation;
            })
        }
        else if(statesRequired?.field_category.length > 0){
	        
	        return requireValidation.when(["field_category"], (value: string) => {
		        
				var required = value && statesRequired.field_category.includes(parseInt(value))
							
		        window.FormSettings[props.form_name][name].required = required
		        
		        return required ? requireValidation.required("Cannot be blank") : requireValidation;
		    })
        }
        else if(fieldRequired){
            return requireValidation.required("Cannot be blank");
        }
        else{
            return requireValidation;
        }

    };

    const setInitValues = (currentField : any, delta: number, parent_field?: any, parent_delta?: any) =>{
        if(typeof currentField !== 'undefined' ){
            let cleanedInitValue: any
            cleanedInitValue = currentField.value;
            if(currentField.value &&  !Array.isArray(currentField.value) && typeof currentField.value != 'object'){
                cleanedInitValue = currentField.value;
            }
            else if(currentField.value && currentField.value.fids){
               // console.log(currentField)
                cleanedInitValue = ''
            }
            else if(currentField.value && Array.isArray(currentField.value)){
                cleanedInitValue = currentField.value[0];
            }
            else if(typeof currentField.value === 'object' && !Array.isArray(currentField.value) && currentField.value !== null){
                cleanedInitValue = Object.values(currentField.value)[0];
            }
            else{
                cleanedInitValue = '';
            }
            
            //
            //INIT VALUE BY NAME FIELD
            //
            
            var name_eval: string = 'initValues'
            var name_parts = currentField.name.split('.')
            
            if(name_parts.length > 1){
            //	console.log("name_parts", name_parts, parent_field, parent_delta, cleanedInitValue)
            }
            //INIT
            name_parts.forEach((parts: any)=>{
	            
	            if(isNaN(parts)){
	            	name_eval += "['" + parts +  "']"
	            }else{
		            name_eval += "[" + parts +  "]"
	            }
	            
	            var eval_code = "if(typeof "+name_eval+" === 'undefined'){"
	            eval_code += name_eval + " = {}"
	            eval_code += '}'
				
			//	console.log(name_eval)
				eval(eval_code)
				
            })
			//SET VALUE
            eval(name_eval + " = cleanedInitValue")
            
            
            /*
			if(typeof parent_field !== 'undefined' && typeof parent_field.parent_name !== 'undefined' ){
				console.log("parent_field", parent_field)
				
				
				var parent_fieldname = parent_field.name;
				if(typeof parent_field.child_name != 'undefined'){
					parent_fieldname = parent_field.child_name
				}
				
				
				if(typeof initValues[parent_field.parent_name] === 'undefined'){
                    initValues[parent_field.parent_name] = { }
                }
                if(typeof initValues[parent_field.parent_name][delta] === 'undefined'){
                    initValues[parent_field.parent_name][delta] = {}
                }
                
                
				if(typeof initValues[parent_field.parent_name][delta][parent_fieldname] === 'undefined'){
                    initValues[parent_field.parent_name][delta][parent_fieldname] = {}
                }
                if(typeof initValues[parent_field.parent_name][delta][parent_fieldname][parent_delta] === 'undefined'){
                    initValues[parent_field.parent_name][delta][parent_fieldname][parent_delta] = {}
                }
                
				if(typeof initValues[parent_field.parent_name][delta][parent_fieldname][parent_delta][currentField.child_name] === 'undefined'){
                    initValues[parent_field.parent_name][delta][parent_fieldname][parent_delta][currentField.child_name] = {}
                }
                
                
                console.log("currentFieldName", currentField.name, currentField.child_name)
                console.log("initValues", parent_fieldname, parent_delta, currentField.child_name, delta)
                console.log("currentField", currentField, cleanedInitValue)
                console.log("cleanedInitValue", cleanedInitValue)
                
                initValues[parent_field.parent_name][delta][parent_fieldname][parent_delta][currentField.child_name] = cleanedInitValue
                
			}else{
				if(currentField.name && currentField.parent_name){
	                if(typeof initValues[currentField.parent_name] === 'undefined'){
	                    initValues[currentField.parent_name] = {}
	                }
	                if(typeof initValues[currentField.parent_name][delta] === 'undefined'){
	                    initValues[currentField.parent_name][delta] = {}
	                }
	                initValues[currentField.parent_name][delta][currentField.child_name] = cleanedInitValue;
	            }
	            else{
	                initValues[currentField.name] = cleanedInitValue;
	            }
            }
            */
            
            
            
           // console.log('initValues', initValues);
            schemaObject[currentField.name] = getValidationRule(currentField, props.form_name)
        }
    }
    
    const initValueRecursif = (currentField: any, current_delta: any, parent_field?: any, parent_delta?: any) => {
	    
	    if(currentField.subform){
            Object.values(currentField.subform).forEach((field_delta: any, delta:number)=>{
                if(typeof field_delta != "undefined"){
                    Object.values(field_delta.structure).forEach((subgroup: any, k) => {
	                    if(subgroup.children){
	                        Object.values(subgroup.children).forEach((subfield: any, i) => {
	                            initValueRecursif(window.FormSettings[props.form_name][subfield], current_delta, currentField, delta)
	                        })
                        }
                    })
                }
            })
        }
        else{
            setInitValues(currentField, current_delta, parent_field, parent_delta)
        } 
    }
    
    
  //  console.log('FORM WINDOW FIELDS',window.FormSettings[form_name][props.form_name])
 // console.log("props.form_name", props.form_name)
    Object.values(window.FormSettings[props.form_name][props.items].children).forEach((item: any) => {
        Object.values(window.FormSettings[props.form_name][item].children).forEach((field: any) => {
	        const currentField = window.FormSettings[props.form_name][field]
	        initValueRecursif(currentField, 0)
	        /*
            const currentField = window.FormSettings[props.form_name][field]
            if(currentField.subform){
                Object.values(currentField.subform).forEach((field_delta: any, delta:number)=>{
	                if(typeof field_delta != "undefined"){
	                    Object.values(field_delta.structure).forEach((subgroup: any, k) => {
	                        Object.values(subgroup.children).forEach((subfield: any, i) => {
	                            setInitValues(window.FormSettings[props.form_name][subfield], delta)
	                        })
	                    })
                    }
                })
            }
            else{
                setInitValues(currentField, 0)
            }
            */

        })
    })

 //   console.log('INIT VALUES FORMIK',initValues)
    const schemaForm :any = Yup.object().shape(schemaObject)
    console.log(schemaForm);
    const [currentSchema, setCurrentSchema] = useState(schemaForm)

    const loadStepper = () => {
        stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)

    }

    const prevStep = () => {
        if (!stepper.current) {
            return
        }


        stepper.current.goPrev()

        setSubmitButton(stepper.current.currentStepIndex === stepper.current.totatStepsNumber)
        
        setCurrentSchema(schemaForm[stepper.current.currentStepIndex - 1])
        //setCurrentSchema(schemaForm)
    }

    const nextStep = (props_form: any) => {
        if (!stepper.current) {
            return
        }

        //
        //VALIDATION STEP
        //
        //GET FIELD CURRET STEP
        var current_group_name = parent.children[stepper.current.currentStepIndex - 1]
        var current_group_form = window.FormSettings[props.form_name][current_group_name]
		
		//CHECK CHILDREN
		var error_step = false
		
		var values = props_form.values
		
		//TRIGGER VALIDATION RULES
		props_form.validateForm()
		current_group_form.children.forEach((child: any) => {
			var formField = window.FormSettings[props.form_name][child]
			
			if(formField.required  && formField.visible && (values[formField.name] == "" || values[formField.name] == null || typeof values[formField.name] == "undefined")){
				console.log("formField", formField, formField.name, values)
				error_step = true
			}
		})
		
		if(!error_step){
		    setErrorMess('')
	        stepper.current.goNext()

	        setSubmitButton(stepper.current.currentStepIndex === stepper.current.totatStepsNumber)
		}
        else{
            setErrorMess(intl.formatMessage({id: 'EDHEC.ERROR_FORM'}))
        }



        //setCurrentSchema(schemaForm[stepper.current.currentStepIndex])
        setCurrentSchema(schemaForm)
    }

    const submitStep = (values: any, actions: FormikValues) => {
	    
	    console.log("step", stepper.current, stepper);
	    
        if (!stepper.current) {
            return
        }

        setSubmitButton(stepper.current.currentStepIndex === stepper.current.totatStepsNumber! - 1)

        //setCurrentSchema(schemaForm[stepper.current.currentStepIndex])
        setCurrentSchema(schemaForm)

        if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {

            stepper.current.goNext()
        } else {

            stepper.current.goto(1)
            
	        if(window.FormSettings[props.form_name].nosubmit !== 1){
            	SubmitForm(values, props.type, props.user, props.form_name, props.nid!, setSubmitId)
            
		        if(props.success_message){
					localStorage.setItem("message", props.success_message)
				}else{
					localStorage.setItem("message", "Your modifications have been saved")
				}
				
	            actions.resetForm()
	
	              setTimeout(()=>{
	                  history.push(props.destination)
	              },200)
            }
        }
    }

    useEffect(() => {
	    
	    //console.log("step useEffect", stepperRef.current, stepperRef);
	    
        if (!stepperRef.current) {
            return
        }
        loadStepper()
    }, [stepperRef])

    const parent = window.FormSettings[props.form_name][props.items]

    let stepNb = 0
    const resetStepNb = () =>{
        stepNb = 0
        return true
    }
    const setStepNb = () =>{
        stepNb = stepNb+1
    }
    
    if(submitId){
	    
	    var type = props.type;
	    
	    if(type === 'researcher'){
		    type = 'profile'
	    }
	    
	    
	    //REDIRECT EDIT
	    window.location.href = '/'+type+'/edit/' + submitId
	    
    }
    
    const state_modal = props.state_modal

    return (
        <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={submitStep}>
            {(props: FormikProps<any>) => (
                <div className='card mt-5'>
                    <div className='card-body'>
                        <div
                            ref={stepperRef}
                            className='stepper stepper-links d-flex flex-column'
                            id='kt_create_account_stepper'
                        >
                            <div className='stepper-nav mb-5'>
                                {resetStepNb()}
                                {ToArray(parent.children).map((child,i) =>(
                                    checkChildren(window.FormSettings[form_name][child], props, form_name) && (
                                        <div id={window.FormSettings[form_name][child].title.toLowerCase()}
                                             key={window.FormSettings[form_name][child].title}
                                             className={stepNb === 0 ? 'stepper-item pb-2 current' : 'pb-2 stepper-item'} data-kt-stepper-element='nav'>
                                            <h3 className='stepper-title'>{window.FormSettings[form_name][child].title}</h3>
                                            {setStepNb()}
                                            {stepper.current?.setTotalStep(stepNb)}
                                        </div>
                                    )
                                ))}
                            </div>
                            <Form className='mx-auto mw-800px w-100 pb-10' id='kt_create_account_form'>
                                {ToArray(parent.children).map((child,index) => (
                                    checkChildren(window.FormSettings[form_name][child], props, form_name) && (
                                        <div id={window.FormSettings[form_name][child].title.toLowerCase()} key={index} className={index === 0 ? 'current' : ''} data-kt-stepper-element='content'>
                                            <div className='w-100'>
                                                <BuilderForm items={[child.toString()]} form_name={form_name} formikProps={props} state_modal={state_modal} showGroupLabel></BuilderForm>
                                            </div>
                                        </div>
                                    )
                                ))}
                                { errorMess != '' ?(

                                    <div className='alert alert-danger alert-dismissible'>
                                        {errorMess}
                                    </div>
                                ):(
                                    <></>
                                )}
                                <div className='d-flex flex-stack mt-10'>
                                    <div className='mr-2'>
                                        <button
                                            onClick={prevStep}
                                            type='button'
                                            className='btn btn-lg btn-light-primary me-3'
                                            data-kt-stepper-action='previous'
                                        >
                                            <KTSVG
                                                path='/media/icons/duotune/arrows/arr063.svg'
                                                className='svg-icon-4 me-1'
                                            />
                                            {intl.formatMessage({id: 'AUTH.GENERAL.BACK_BUTTON'})}
                                        </button>
                                    </div>


	                                    <div>
	                                          {window.FormSettings[form_name].nosubmit !== 1 && isSubmitButton && (
                                                  <button type='submit' className='btn btn-lg btn-primary me-3'>
                                                      <span className='indicator-label'>
                                                          <span>
                                                              {isSubmitButton && intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                                                          </span>

	                                              <KTSVG
                                                      path='/media/icons/duotune/arrows/arr064.svg'
                                                      className='svg-icon-3 ms-2 me-0'
                                                  />
                                                      </span>
                                                  </button>
	                                            )}
	                                            {(window.FormSettings[form_name].nosubmit === 1 || !isSubmitButton)  && (
													
                                                    <button
                                                    onClick={() => {
	                                                    nextStep(props)
                                                    }}
                                                    type='button'
                                                    className='btn btn-lg btn-primary me-3'
                                                    data-kt-stepper-action='next'
                                                    >
                                                    Continue
                                                        <KTSVG
                                                            path='/media/icons/duotune/arrows/arr064.svg'
                                                            className='svg-icon-3 ms-2 me-0'
                                                        />
                                                    </button>
	                                            )}
	                                    </div>


	                                </div>
                                <small className='d-block mt-3'><span className='red'>*</span>{intl.formatMessage({id: 'EDHEC.MANDATORY_FIELDS'})}</small>
                            </Form>
                        </div>
                    </div>
                </div>
            )}
        </Formik>
    )
}

export {FormStepHorizontal}
